import axios from "axios";
import axiosInstance from "../scenes/utils/axiosInstance";
import { API_BASE_URL, API_ENDPOINTS } from "../config/api";

export default class DoctorService {
  doctorLogin(doctorData) {
    return axios.post(
      `${API_BASE_URL}${API_ENDPOINTS.AUTH.LOGIN_DOCTOR}`,
      doctorData
    );
  }
  
  getDoctorInfo = async () => {
    const doctorId = localStorage.getItem("doctorId"); //LocalStorage'dan doctorId'yi getirdim.
    
    // doctorId null veya undefined ise, token'dan al
    if (!doctorId || doctorId === "null" || doctorId === "undefined") {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const id = user.id;
      
      if (!id) {
        console.error("Doctor ID not found in localStorage");
        return null;
      }
      
      try {
        const response = await axiosInstance.get(
          API_ENDPOINTS.DOCTORS.BY_ID(id)
        );
        console.log("Doctor info:", response.data);
        return response.data;
      } catch (error) {
        console.error("Error fetching doctor info:", error.message);
        if (error.response?.status !== 403) {
          alert("Failed to fetch doctor info.");
        }
        return null;
      }
    }

    try {
      const response = await axiosInstance.get(
        API_ENDPOINTS.DOCTORS.BY_ID(doctorId)
      );
      console.log("Doctor info:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching doctor info:", error.message);
      if (error.response?.status !== 403) {
        alert("Failed to fetch doctor info.");
      }
      return null; 
    }
  };

  // Get another doctor's info by ID (for viewing subordinate doctors)
  getDoctorInfoById = async (doctorId) => {
    try {
      const response = await axiosInstance.get(
        API_ENDPOINTS.DOCTORS.BY_ID(doctorId)
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching doctor info by ID:", error);
      throw error;
    }
  };

  registerDoctor = async (data)=>{
    try{
      const response = await axiosInstance.post(API_ENDPOINTS.AUTH.ADMIN_REGISTER_DOCTOR, data);
      return response.data;
    }catch(error){
      console.log("Ekleme Sırasında Hata Meydana Geldi.")
      if (error.response?.status !== 403) {
        alert("Failed to fetch doctor info.");
      }
      return null; 
    }
  }

  getAllDoctor = async (options = {})=>{
    try{
      const response = await axiosInstance.get(API_ENDPOINTS.DOCTORS.ALL, options);
      if (options.withMeta) {
        return { data: response.data, headers: response.headers };
      }
      return response.data;
    }catch(error){
      console.log("Bir sorun oluştu.")
    }
  }

  exportDoctorsExcel = async (filters = {}) => {
    const response = await axiosInstance.get(API_ENDPOINTS.DOCTORS.EXPORT_EXCEL, {
      params: filters,
      responseType: "blob",
    });
    return response;
  }
  
  addDoctor = async (data)=>{
    try{
      const response = await axiosInstance.post(API_ENDPOINTS.AUTH.ADMIN_REGISTER_DOCTOR, data)
      return response.data
    }catch(error){
      console.log("Bir sorun oluştu.")
    }
  }
  
  // 🆕 YENİ: Alt doktor davet etme (email ile + permission groups)
  inviteDoctor = async (email, role_title, permissionGroupIds = null) => {
    try {
      const requestBody = { email, role_title };
      
      // Permission group IDs varsa ekle
      if (permissionGroupIds && Array.isArray(permissionGroupIds) && permissionGroupIds.length > 0) {
        requestBody.permissionGroupIds = permissionGroupIds;
      }
      
      const response = await axiosInstance.post(
        API_ENDPOINTS.AUTH.ADMIN_INVITE_DOCTOR,
        requestBody
      );
      return response.data;
    } catch (error) {
      console.error("Doktor daveti gönderilirken hata oluştu:", error);
      throw error;
    }
  }
  requestPasswordOtp = async (email) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}${API_ENDPOINTS.AUTH.PASSWORD_FORGOT}`,
        { email }
      );
      return response.data;
    } catch (error) {
      console.error("Şifre sıfırlama OTP isteğinde hata oluştu:", error);
      throw error;
    }
  };

  verifyPasswordOtp = async ({ email, otp }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}${API_ENDPOINTS.AUTH.PASSWORD_VERIFY_OTP}`,
        { email, otp }
      );
      return response.data;
    } catch (error) {
      console.error("OTP doğrulanırken hata oluştu:", error);
      throw error;
    }
  };

  resetPassword = async ({ resetToken, newPassword, confirmPassword }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}${API_ENDPOINTS.AUTH.PASSWORD_RESET}`,
        {
          resetToken,
          new_password: newPassword,
          confirm_password: confirmPassword,
        }
      );
      return response.data;
    } catch (error) {
      console.error("Şifre sıfırlanırken hata oluştu:", error);
      throw error;
    }
  };

  // Update doctor information
  updateDoctor = async (doctorId, updateData) => {
    try {
      const response = await axiosInstance.put(
        API_ENDPOINTS.DOCTORS.UPDATE(doctorId),
        updateData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating doctor:", error);
      throw error;
    }
  };
}
